// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.in-person-form .sk-input__input,\n.in-person-form .sk-input__textarea,\n.in-person-form .sk-select {\n  background-color: #fff;\n}\n.in-person-form .sk-input__textarea {\n  height: 80px;\n}\n", ""]);
// Exports
module.exports = exports;
